import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import moment from 'moment'
import request from 'superagent'
import util from '../../helper/util'
import swal from 'sweetalert'

let photo_default = "../../swipe/assets/app/media/img/users/default.jpg"

class ModalProfile extends Component {

    constructor(props) {
        super(props)
        this.state = {
        	type: "", flag_load_data: true,
            sel_identitas: "", identitas_nomer: "", nomor_npwp: "",
            sel_gender: "", name_full: "", email: "", fax: "", tempat_lahir: "", tanggal_lahir: "", pekerjaan: "",
            propinsi: "", kota: "", kecamatan: "", kelurahan: "", alamat: "", kode_pos: "",
            kota_nama: "", kecamatan_nama: "", kelurahan_nama: "", flag_processing: false, photo_url: photo_default,
            deposit_name: "", deposit_value: "", nomor_telepon: "", user_id: "", username: "", status: "", propinsi_nama: "", settings: "", bank_accounts: []
        }
    }

    componentDidMount() {
        let self = this
        let type = ''
        if (this.props.data.type) {
        	type = this.props.data.type
        }
        util.log(type)
        if (type === 'public') {
        	this.public_profile()
	    } else {
	    	this.get_profile()
	    }
    }

    public_profile() {
    	if (this.props.data.url) {
    		let self = this
	        request.get(this.props.data.url)
	            .set("Content-Type", "application/json")
	            .end(function(err, res) {
	                if (err || !res.ok) {
	                    util.log("public_profile", err)
	                } else {
	                    util.log("public_profile", res)
	                    if (res.statusCode == 200) {
	                        let payload = res.body
	                        if (payload.status == "OK") {
	                        	if (payload.results) {
	                                let results = payload.results
	                                self.public_corporate_payload(results)
	                            }
	                        }
	                    }
	                }
	            })
    	}
    }

    get_profile() {
    	if (this.props.data.url) {
			let body = {
	            "session_id" : this.props.session
	        }
	        let self = this
	        request.post(this.props.data.url)
	            .set("Content-Type", "application/json")
	            .send(body)
	            .end(function(err, res) {
	                if (err || !res.ok) {
	                    util.log("get_profile", err)
	                } else {
	                    util.log("get_profile", res);
	                    if (res.statusCode == 200) {
	                        let payload = res.body
	                        if (payload.status == "OK") {
	                        	if (payload.results) {
	                                let results = payload.results
                                    if (payload.type === 'AGENT_DETAIL') {
                                        self.agent_payload(results)
                                    } else if (payload.type === 'MASTER_AGENT_DETAIL') {
                                        self.master_agent_payload(results)
                                    } else {
                                        swal("Error", "Tipe profil tidak dikenal", "error")
                                    }
	                            }
	                        }
	                    }
	                }
	            })
    	}
    }

    agent_payload(results) {
    	let profile = results.profile
        let res = {
        	"type" : "private-agent",
        	"user_id" : results.agent_id !== undefined ? results.agent_id : "",
        	"username" : results.username,
        	"status" : results.status,
            "name_full" : profile.fullname !== undefined ? profile.fullname : "",
            "email" : profile.email !== undefined ? profile.email : "",
            "fax" : profile.fax_number !== undefined ? profile.fax_number : "",
            "tempat_lahir" : profile.place_birth !== undefined ? profile.place_birth : "",
            "tanggal_lahir" : profile.birth_date !== undefined ? profile.birth_date : "",
            "pekerjaan" : profile.job_title !== undefined ? profile.job_title : "",
            "sel_gender" : profile.gender !== undefined ? profile.gender : "",
            "sel_identitas" : profile.id_card_type !== undefined ? profile.id_card_type : "",
            "identitas_nomer" : profile.id_card_number !== undefined ? profile.id_card_number : "",
            "foto_identitas" : profile.id_card_filename !== undefined ? profile.id_card_filename : "",
            "nomor_npwp" : profile.npwp_number !== undefined ? profile.npwp_number : "",
            "propinsi" : profile.province_id !== undefined ? profile.province_id : "",
            "propinsi_nama" : profile.province_name !== undefined ? profile.province_name : "",
            "kota" : profile.city_id !== undefined ? profile.city_id : "",
            "kota_nama" : profile.city_name !== undefined ? profile.city_name : "",
            "kecamatan" : profile.district_id !== undefined ? profile.district_id : "",
            "kecamatan_nama" : profile.district_name !== undefined ? profile.district_name : "",
            "kelurahan" : profile.village_id !== undefined ? profile.village_id : "",
            "kelurahan_nama" : profile.village_name !== undefined ? profile.village_name : "",
            "alamat" : profile.address !== undefined ? profile.address : "",
            "kode_pos" : profile.postal_code !== undefined ? profile.postal_code : "",
            "photo_url" : profile.photo_filename !== undefined && profile.photo_filename.length !== 0 ? profile.photo_filename : photo_default,
            "nomor_telepon" : profile.phone_number !== undefined ? profile.phone_number : "",
            "deposit_name" : results.list_balances.deposits[0].balance_name,
            "deposit_value" : results.list_balances.deposits[0].balance_value,
            "flag_load_data" : false,
            "bank_accounts" : results.bank_accounts ? results.bank_accounts : []
        }
        if (profile.profile_type && profile.profile_type === 'CORPORATE') {
        	res.type = 'private-corporate'
        }

        let settings = {}
        if (results.default_trx_commission && results.default_trx_commission !== null) {
            settings.default_komisi_is_used = results.default_trx_commission.default_commission_used
            settings.default_komisi_text = results.default_trx_commission.default_commission_value
            settings.default_komisi_type = results.default_trx_commission.default_commission_type
        }
        if (results.default_trx_bonus && results.default_trx_bonus !== null) {
            settings.default_bonus_is_used = results.default_trx_bonus.default_bonus_used
            settings.default_bonus_text = results.default_trx_bonus.default_bonus_value
            settings.default_bonus_type = results.default_trx_bonus.default_bonus_type
        }
        if (results.downline && results.downline !== null) {
            if (results.downline.master_agent && results.downline.master_agent !== null) {
                let ma = results.downline.master_agent
                if (ma.master_agent_max_downline) {
                    settings.max_downline = ma.master_agent_max_downline
                }
                if (ma.default_commission_base_on && ma.default_commission_base_on !== null) {
                    if (ma.default_commission_base_on && ma.default_commission_base_on !== null) {
                        let dcbo = ma.default_commission_base_on
                        if (dcbo.upline && dcbo.upline !== null) {
                            settings.default_komisi_upline_is_used = dcbo.upline.default_commission_used
                            settings.default_komisi_upline_text = dcbo.upline.default_commission_value
                            settings.default_komisi_upline_type = dcbo.upline.default_commission_type
                        }
                        if (dcbo.level && dcbo.level !== null) {
                            settings.default_komisi_level_is_used = dcbo.level.default_commission_used
                            settings.default_komisi_level_text = dcbo.level.default_commission_value
                            settings.default_komisi_level_type = dcbo.level.default_commission_type
                        }
                    }
                    if (ma.default_bonus_base_on && ma.default_bonus_base_on !== null) {
                        let dbbo = ma.default_bonus_base_on
                        if (dbbo.upline && dbbo.upline !== null) {
                            settings.default_bonus_upline_is_used = dbbo.upline.default_bonus_used
                            settings.default_bonus_upline_text = dbbo.upline.default_bonus_value
                            settings.default_bonus_upline_type = dbbo.upline.default_bonus_type
                        }
                        if (dbbo.level && dbbo.level !== null) {
                            settings.default_bonus_level_is_used = dbbo.level.default_bonus_used
                            settings.default_bonus_level_text = dbbo.level.default_bonus_value
                            settings.default_bonus_level_type = dbbo.level.default_bonus_type
                        }
                    }
                }
            }
            if (results.downline.agent && results.downline.agent !== null) {
                let a = results.downline.agent
                if (a.agent_auto_approve !== null) {
                    settings.agent_auto_approve = a.agent_auto_approve ? "1" : "0"
                }
                if (a.agent_max_terminal_default) {
                    settings.agent_max_terminal = a.agent_max_terminal_default
                }
            }
        }
        if (settings.length !== 0) {
            res.settings = settings
        }
        this.setState(res)
    }

    master_agent_payload(results) {
        let profile = results.profile
        let res = {
            "type" : "private-agent",
            "user_id" : results.master_agent_id !== undefined ? results.master_agent_id : "",
            "username" : results.username,
            "status" : results.status,
            "name_full" : profile.fullname !== undefined ? profile.fullname : "",
            "email" : profile.email !== undefined ? profile.email : "",
            "fax" : profile.fax_number !== undefined ? profile.fax_number : "",
            "tempat_lahir" : profile.place_birth !== undefined ? profile.place_birth : "",
            "tanggal_lahir" : profile.birth_date !== undefined ? profile.birth_date : "",
            "pekerjaan" : profile.job_title !== undefined ? profile.job_title : "",
            "sel_gender" : profile.gender !== undefined ? profile.gender : "",
            "sel_identitas" : profile.id_card_type !== undefined ? profile.id_card_type : "",
            "identitas_nomer" : profile.id_card_number !== undefined ? profile.id_card_number : "",
            "foto_identitas" : profile.id_card_filename !== undefined ? profile.id_card_filename : "",
            "nomor_npwp" : profile.npwp_number !== undefined ? profile.npwp_number : "",
            "propinsi" : profile.province_id !== undefined ? profile.province_id : "",
            "propinsi_nama" : profile.province_name !== undefined ? profile.province_name : "",
            "kota" : profile.city_id !== undefined ? profile.city_id : "",
            "kota_nama" : profile.city_name !== undefined ? profile.city_name : "",
            "kecamatan" : profile.district_id !== undefined ? profile.district_id : "",
            "kecamatan_nama" : profile.district_name !== undefined ? profile.district_name : "",
            "kelurahan" : profile.village_id !== undefined ? profile.village_id : "",
            "kelurahan_nama" : profile.village_name !== undefined ? profile.village_name : "",
            "alamat" : profile.address !== undefined ? profile.address : "",
            "kode_pos" : profile.postal_code !== undefined ? profile.postal_code : "",
            "photo_url" : profile.photo_filename !== undefined && profile.photo_filename.length !== 0 ? profile.photo_filename : photo_default,
            "nomor_telepon" : profile.phone_number !== undefined ? profile.phone_number : "",
            "deposit_name" : results.list_balances.deposits[0].balance_name,
            "deposit_value" : results.list_balances.deposits[0].balance_value,
            "flag_load_data" : false,
            "bank_accounts" : results.bank_accounts ? results.bank_accounts : []
        }
        if (profile.profile_type && profile.profile_type === 'CORPORATE') {
            res.type = 'private-corporate'
        }

        let settings = {}
        if (results.default_trx_commission && results.default_trx_commission !== null) {
            settings.default_komisi_is_used = results.default_trx_commission.default_commission_used
            settings.default_komisi_text = results.default_trx_commission.default_commission_value
            settings.default_komisi_type = results.default_trx_commission.default_commission_type
        }
        if (results.default_trx_bonus && results.default_trx_bonus !== null) {
            settings.default_bonus_is_used = results.default_trx_bonus.default_bonus_used
            settings.default_bonus_text = results.default_trx_bonus.default_bonus_value
            settings.default_bonus_type = results.default_trx_bonus.default_bonus_type
        }
        if (results.downline && results.downline !== null) {
            if (results.downline.master_agent && results.downline.master_agent !== null) {
                let ma = results.downline.master_agent
                if (ma.master_agent_max_downline) {
                    settings.max_downline = ma.master_agent_max_downline
                }
                if (ma.default_commission_base_on && ma.default_commission_base_on !== null) {
                    if (ma.default_commission_base_on && ma.default_commission_base_on !== null) {
                        let dcbo = ma.default_commission_base_on
                        if (dcbo.upline && dcbo.upline !== null) {
                            settings.default_komisi_upline_is_used = dcbo.upline.default_commission_used
                            settings.default_komisi_upline_text = dcbo.upline.default_commission_value
                            settings.default_komisi_upline_type = dcbo.upline.default_commission_type
                        }
                        if (dcbo.level && dcbo.level !== null) {
                            settings.default_komisi_level_is_used = dcbo.level.default_commission_used
                            settings.default_komisi_level_text = dcbo.level.default_commission_value
                            settings.default_komisi_level_type = dcbo.level.default_commission_type
                        }
                    }
                    if (ma.default_bonus_base_on && ma.default_bonus_base_on !== null) {
                        let dbbo = ma.default_bonus_base_on
                        if (dbbo.upline && dbbo.upline !== null) {
                            settings.default_bonus_upline_is_used = dbbo.upline.default_bonus_used
                            settings.default_bonus_upline_text = dbbo.upline.default_bonus_value
                            settings.default_bonus_upline_type = dbbo.upline.default_bonus_type
                        }
                        if (dbbo.level && dbbo.level !== null) {
                            settings.default_bonus_level_is_used = dbbo.level.default_bonus_used
                            settings.default_bonus_level_text = dbbo.level.default_bonus_value
                            settings.default_bonus_level_type = dbbo.level.default_bonus_type
                        }
                    }
                }
            }
            if (results.downline.agent && results.downline.agent !== null) {
                let a = results.downline.agent
                if (a.agent_auto_approve !== null) {
                    settings.agent_auto_approve = a.agent_auto_approve ? "1" : "0"
                }
                if (a.agent_max_terminal_default) {
                    settings.agent_max_terminal = a.agent_max_terminal_default
                }
            }
        }
        if (settings.length !== 0) {
            res.settings = settings
        }
        this.setState(res)
    }

    public_corporate_payload(profile) {
    	let res = {
    		"type" : "public-corporate",
            "name_full" : profile.fullname !== undefined ? profile.fullname : "",
            "email" : profile.email !== undefined ? profile.email : "",
            "fax" : profile.fax_number !== undefined ? profile.fax_number : "",
            "nomor_npwp" : profile.npwp_number !== undefined ? profile.npwp_number : "",
            "propinsi_nama" : profile.province_name !== undefined ? profile.province_name : "",
            "kota_nama" : profile.city_name !== undefined ? profile.city_name : "",
            "kecamatan" : profile.district_id !== undefined ? profile.district_id : "",
            "kecamatan_nama" : profile.district_name !== undefined ? profile.district_name : "",
            "kelurahan" : profile.village_id !== undefined ? profile.village_id : "",
            "kelurahan_nama" : profile.village_name !== undefined ? profile.village_name : "",
            "alamat" : profile.address !== undefined ? profile.address : "",
            "kode_pos" : profile.postal_code !== undefined ? profile.postal_code : "",
            "photo_url" : profile.photo_filename !== undefined && profile.photo_filename.length !== 0 ? profile.photo_filename : photo_default,
            "nomor_telepon" : profile.phone_number !== undefined ? profile.phone_number : "",
            "company_name" : profile.company_name !== undefined ? profile.company_name : "",
            "branch_office_level" : profile.branch_office_level !== undefined ? profile.branch_office_level : "",
            "flag_load_data" : false
        }

        this.setState(res)
    }

    render() {
    	let data = this.props.data
    	const BankAccountView = (props) =>
            <div className="m-stack m-stack--ver m-stack--mobile m-stack--demo" style={{marginBottom: 20+'px',marginTop: 10+'px'}}>
                <div className="m-stack__item m-stack__item--center m-stack__item--top" 
                        style={{textAlign:'center',lineHeight: '30px'}}>
                        <span>Bank Virtual Account:</span>
                        <br/>
                    {this.state.bank_accounts.map((item, i) =>
                        <span key={i} className="m-badge m-badge--metal m-badge--wide" style={{marginRight:'5px'}}>{item.bank_name} {item.account_number}</span>
                    )}
                </div>
            </div>

        const CorporatePublicProfileView = (props) =>
        	<div className="row">
            	<div className="col-lg-12">
                    <div className="m-portlet__body">
                    	<div className="m-card-profile__pic">
                            <div className="m-card-profile__pic-wrapper" style={{textAlign: 'center'}}>
                                <img src={this.state.photo_url} style={{width:100+'px',height:100+'px'}}/>
                            </div>
                        </div>
                        <div className="m-card-profile__details" style={{textAlign: 'center', marginTop:5+'px'}}>
                            <span className="m-card-profile__name">
                                {this.state.profile_type} {this.state.company_name}
                            </span>
                        </div>

                        <div style={{margin: '0 10px'}}>
                            <div className="form-group m-form__group row">
                                <div className="col-10">
                                    <h3 className="m-form__section">
                                        1. Company Info
                                    </h3>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Nama
                                </label>
                                <div className="col-9" style={{margin: 'auto 0'}}>
                                    <input disabled className="form-control m-input" type="text" 
                                        name="name_full"
                                        value={this.state.name_full}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Cabang
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                        name="branch_office_level"
                                        value={this.state.branch_office_level}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Telepon
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                    name="nomor_telepon"
                                    value={this.state.nomor_telepon}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    NPWP
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                    name="nomor_npwp"
                                    value={this.state.nomor_npwp}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Email
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                    name="email"
                                    value={this.state.email}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Fax
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                        name="fax"
                                        value={this.state.fax}/>
                                </div>
                            </div>
                            <div className="" style={{marginTop: '30px'}}></div>
                            <div className="form-group m-form__group row">
                                <div className="col-10">
                                    <h3 className="m-form__section">
                                        2. Alamat 
                                    </h3>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Provinsi
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                        name="propinsi_nama"
                                        value={this.state.propinsi_nama}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Kota
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                        name="kota_nama"
                                        value={this.state.kota_nama}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        const AgentProfileView = (props) =>
        	<div className="row">
            	<div className="col-lg-12">
                    <div className="m-portlet__body">
                        <div className="m-card-profile__pic">
                            <div className="m-card-profile__pic-wrapper" style={{textAlign: 'center'}}>
                                <img src={this.state.photo_url} style={{width:100+'px',height:100+'px'}}/>
                            </div>
                        </div>
                        <div className="m-card-profile__details" style={{textAlign: 'center', marginTop:5+'px'}}>
                            <span className="m-card-profile__name">
                                {this.state.username} {this.state.user_id.length !== 0 ? "(" + this.state.user_id + ")" : ''}
                            </span>
                        	<br/>
                            <span className="m-card-profile__email">
                                {this.state.status}
                            </span>
                        </div>

                        <div className="m-stack m-stack--ver m-stack--mobile m-stack--demo" style={{marginBottom: 20+'px',marginTop: 10+'px'}}>
			                <div className="m-stack__item m-stack__item--center m-stack__item--top" 
		                        style={{textAlign: 'center'}}>
		                        {this.state.deposit_name} : {this.state.deposit_value}
		                    </div>
			            </div>

                        {this.state.bank_accounts.length !== 0 ? <BankAccountView/> : ''}

                        <div style={{margin: '0 10px'}}>
                            <div className="form-group m-form__group row">
                                <div className="col-10">
                                    <h3 className="m-form__section">
                                        1. Kartu Identitas
                                    </h3>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Tipe Kartu Identitas
                                </label>
                                <div className="col-9" style={{margin: 'auto 0'}}>
                                    <input disabled className="form-control m-input" type="text" 
                                        name="sel_identitas"
                                        value={this.state.sel_identitas}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Nomor Kartu Identitas
                                </label>
                                <div className="col-9" style={{margin: 'auto 0'}}>
                                    <input disabled className="form-control m-input" type="text" 
                                        name="identitas_nomer"
                                        value={this.state.identitas_nomer}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Nama Lengkap
                                </label>
                                <div className="col-9" style={{margin: 'auto 0'}}>
                                    <input disabled className="form-control m-input" 
                                    name="name_full"
                                    type="text" 
                                    value={this.state.name_full}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Foto Kartu Identitas
                                </label>
                                <div className="col-9" style={{margin: 'auto 0'}}>
                                    {this.state.foto_identitas ? <span style={{fontWeight: '600'}}><a href={this.state.foto_identitas} target='_blank'>Klik Disini</a></span> : ''}
                                </div>
                            </div>
                            <div className="" style={{marginTop: '30px'}}></div>
                            <div className="form-group m-form__group row">
                                <div className="col-10">
                                    <h3 className="m-form__section">
                                        2. Personal Info
                                    </h3>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Telepon
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                    name="nomor_telepon"
                                    value={this.state.nomor_telepon}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    NPWP
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                    name="nomor_npwp"
                                    value={this.state.nomor_npwp}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Email
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                    name="email"
                                    value={this.state.email}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Jenis Kelamin
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                        name="sel_gender"
                                        value={this.state.sel_gender}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Fax
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                        name="fax"
                                        value={this.state.fax}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Tempat Lahir
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                        name="tempat_lahir"
                                        value={this.state.tempat_lahir}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Tanggal Lahir
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                        name="tanggal_lahir"
                                        value={this.state.tanggal_lahir}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Pekerjaan
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                        name="pekerjaan"
                                        value={this.state.pekerjaan}/>
                                </div>
                            </div>
                            <div className="" style={{marginTop: '30px'}}></div>
                            <div className="form-group m-form__group row">
                                <div className="col-10">
                                    <h3 className="m-form__section">
                                        3. Alamat Domisili
                                    </h3>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Provinsi
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                        name="propinsi_nama"
                                        value={this.state.propinsi_nama}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Kota
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                        name="kota_nama"
                                        value={this.state.kota_nama}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Kecamatan
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                        name="kecamatan_nama"
                                        value={this.state.kecamatan_nama}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Kelurahan
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                        name="kelurahan_nama"
                                        value={this.state.kelurahan_nama}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Alamat Lengkap
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                        name="alamat"
                                        value={this.state.alamat}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Kode Pos
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                    name="kode_pos"
                                    value={this.state.kode_pos}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        const CorporatePrivateProfileView = (props) =>
        	<div className="row">
            	<div className="col-lg-12">
                    <div className="m-portlet__body">
                        <div className="m-card-profile__pic">
                            <div className="m-card-profile__pic-wrapper" style={{textAlign: 'center'}}>
                                <img src={this.state.photo_url} style={{width:100+'px',height:100+'px'}}/>
                            </div>
                        </div>
                        <div className="m-card-profile__details" style={{textAlign: 'center', marginTop:5+'px'}}>
                            <span className="m-card-profile__name">
                                {this.state.username} {this.state.user_id.length !== 0 ? "(" + this.state.user_id + ")" : ''}
                            </span>
                        	<br/>
                            <span className="m-card-profile__email">
                                {this.state.status}
                            </span>
                        </div>

                        <div className="m-stack m-stack--ver m-stack--mobile m-stack--demo" style={{marginBottom: 20+'px',marginTop: 10+'px'}}>
			                <div className="m-stack__item m-stack__item--center m-stack__item--top" 
		                        style={{textAlign: 'center'}}>
		                        {this.state.deposit_name} : {this.state.deposit_value}
		                    </div>
			            </div>

                        {this.state.bank_accounts.length !== 0 ? <BankAccountView/> : ''}
                        
                        <div style={{margin: '0 10px'}}>
                            <div className="form-group m-form__group row">
                                <div className="col-10">
                                    <h3 className="m-form__section">
                                        1. Company Info
                                    </h3>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Nama
                                </label>
                                <div className="col-9" style={{margin: 'auto 0'}}>
                                    <input disabled className="form-control m-input" 
                                    name="name_full"
                                    type="text" 
                                    value={this.state.name_full}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Cabang
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                        name="branch_office_level"
                                        value={this.state.branch_office_level}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Telepon
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                    name="nomor_telepon"
                                    value={this.state.nomor_telepon}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    NPWP
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                    name="nomor_npwp"
                                    value={this.state.nomor_npwp}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Email
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                    name="email"
                                    value={this.state.email}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Fax
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                        name="fax"
                                        value={this.state.fax}/>
                                </div>
                            </div>
                            <div className="" style={{marginTop: '30px'}}></div>
                            <div className="form-group m-form__group row">
                                <div className="col-10">
                                    <h3 className="m-form__section">
                                        2. Alamat
                                    </h3>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Provinsi
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                        name="propinsi_nama"
                                        value={this.state.propinsi_nama}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Kota
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                        name="kota_nama"
                                        value={this.state.kota_nama}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Kecamatan
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                        name="kecamatan_nama"
                                        value={this.state.kecamatan_nama}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Kelurahan
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                        name="kelurahan_nama"
                                        value={this.state.kelurahan_nama}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Alamat Lengkap
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                        name="alamat"
                                        value={this.state.alamat}/>
                                </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <label htmlFor="example-text-input" className="col-3 col-form-label" style={{textAlign: 'right'}}>
                                    Kode Pos
                                </label>
                                <div className="col-9">
                                    <input disabled className="form-control m-input" type="text" 
                                    name="kode_pos"
                                    value={this.state.kode_pos}/>
                                </div>
                            </div>
                            {this.state.settings.length !== 0 ? <SettingsView/> : ''}
                        </div>
                    </div>
                </div>
            </div>

        const SettingsView = (props) =>
            <div style={{marginTop: '30px'}}>
                <div className="form-group m-form__group row">
                    <div className="col-10">
                        <h3 className="m-form__section">
                            [Settings Downline]
                        </h3>
                    </div>
                </div>
                <div className="form-group m-form__group row">
                    <label className="col-3 col-form-label" style={{textAlign: 'right'}}>
                        Max Downline
                    </label>
                    <div className="col-9" style={{margin:'auto'}}>
                        <input className="form-control m-input" 
                        name="max_downline"
                        type="text" 
                        onChange={(e) => this.on_input_change(e)}
                        value={this.state.settings.max_downline}/>
                    </div>
                </div>
                <div className="form-group m-form__group row">
                    <label className="col-3 col-form-label" style={{textAlign: 'right'}}>
                        Agent Auto Approve
                    </label>
                    <div className="col-9" style={{margin:'auto'}}>
                        <select className="form-control m-input" id="agent_auto_approve" value={this.state.settings.agent_auto_approve} onChange={(e) => this.on_select_change(e)} style={{MozAppearance: 'none',WebkitAppearance: 'none'}}>
                            <option key={999} value=""></option>
                            <option key={0} value="1">Auto Approve</option>
                            <option key={1} value="0">Not Auto Approve</option>
                        </select>
                    </div>
                </div>
                <div className="form-group m-form__group row">
                    <label className="col-3 col-form-label style={{textAlign: 'right'}}">
                        Agent Max Terminal
                    </label>
                    <div className="col-9" style={{margin:'auto'}}>
                        <input className="form-control m-input" 
                        type="text" 
                        name="agent_max_terminal"
                        onChange={(e) => this.on_input_change(e)}
                        value={this.state.settings.agent_max_terminal}/>
                    </div>
                </div>
                <div className="form-group m-form__group row">
                    <label className="col-3 col-form-label" style={{textAlign: 'right'}}>
                        Default Komisi
                    </label>
                    <div className="col-6" style={{margin:'auto'}}>
                        <input className="form-control m-input" 
                        type="text" 
                        name="default_komisi_text"
                        onChange={(e) => this.on_input_change(e)}
                        value={this.state.settings.default_komisi_text}/>
                    </div>
                    <div className="col-3" style={{margin:'auto'}}>
                        <select className="form-control m-input" id="default_komisi_type" value={this.state.settings.default_komisi_type} onChange={(e) => this.on_select_change(e)} style={{MozAppearance: 'none',WebkitAppearance: 'none'}}>
                            <option key={999} value=""></option>
                            <option key={0} value="FIXED">FIXED</option>
                            <option key={1} value="PERCENTAGE">PERCENTAGE</option>
                        </select>
                    </div>
                </div>
                <div className="form-group m-form__group row">
                    <label className="col-3 col-form-label" style={{textAlign: 'right'}}>
                        Default Bonus
                    </label>
                    <div className="col-6" style={{margin:'auto'}}>
                        <input className="form-control m-input" 
                        type="text" 
                        name="default_bonus_text"
                        onChange={(e) => this.on_input_change(e)}
                        value={this.state.settings.default_bonus_text}/>
                    </div>
                    <div className="col-3" style={{margin:'auto'}}>
                        <select className="form-control m-input" id="default_bonus_type" value={this.state.settings.default_bonus_type} onChange={(e) => this.on_select_change(e)} style={{MozAppearance: 'none',WebkitAppearance: 'none'}}>
                            <option key={999} value=""></option>
                            <option key={0} value="FIXED">FIXED</option>
                            <option key={1} value="PERCENTAGE">PERCENTAGE</option>
                        </select>
                    </div>
                </div>
                <div className="form-group m-form__group row">
                    <label className="col-3 col-form-label" style={{textAlign: 'right'}}>
                        Default Komisi<br/>Upline Level
                    </label>
                    <div className="col-6" style={{margin:'auto'}}>
                        <input className="form-control m-input" 
                        type="text" 
                        name="default_komisi_upline_text"
                        onChange={(e) => this.on_input_change(e)}
                        value={this.state.settings.default_komisi_upline_text}/>
                    </div>
                    <div className="col-3" style={{margin:'auto'}}>
                        <select className="form-control m-input" id="default_komisi_upline_type" value={this.state.settings.default_komisi_upline_type} onChange={(e) => this.on_select_change(e)} style={{MozAppearance: 'none',WebkitAppearance: 'none'}}>
                            <option key={999} value=""></option>
                            <option key={0} value="FIXED">FIXED</option>
                            <option key={1} value="PERCENTAGE">PERCENTAGE</option>
                        </select>
                    </div>
                </div>
                <div className="form-group m-form__group row">
                    <label className="col-3 col-form-label" style={{textAlign: 'right'}}>
                        Default Komisi<br/>Downline Level
                    </label>
                    <div className="col-6" style={{margin:'auto'}}>
                        <input className="form-control m-input" 
                        type="text" 
                        name="default_komisi_level_text"
                        onChange={(e) => this.on_input_change(e)}
                        value={this.state.settings.default_komisi_level_text}/>
                    </div>
                    <div className="col-3" style={{margin:'auto'}}>
                        <select className="form-control m-input" id="default_komisi_level_type" value={this.state.settings.default_komisi_level_type} onChange={(e) => this.on_select_change(e)} style={{MozAppearance: 'none',WebkitAppearance: 'none'}}>
                            <option key={999} value=""></option>
                            <option key={0} value="FIXED">FIXED</option>
                            <option key={1} value="PERCENTAGE">PERCENTAGE</option>
                        </select>
                    </div>
                </div>
                <div className="form-group m-form__group row">
                    <label className="col-3 col-form-label" style={{textAlign: 'right'}}>
                        Default Bonus<br/>Upline Level
                    </label>
                    <div className="col-6" style={{margin:'auto'}}>
                        <input className="form-control m-input" 
                        type="text" 
                        name="default_bonus_upline_text"
                        onChange={(e) => this.on_input_change(e)}
                        value={this.state.settings.default_bonus_upline_text}/>
                    </div>
                    <div className="col-3" style={{margin:'auto'}}>
                        <select className="form-control m-input" id="default_bonus_upline_type" value={this.state.settings.default_bonus_upline_type} onChange={(e) => this.on_select_change(e)} style={{MozAppearance: 'none',WebkitAppearance: 'none'}}>
                            <option key={999} value=""></option>
                            <option key={0} value="FIXED">FIXED</option>
                            <option key={1} value="PERCENTAGE">PERCENTAGE</option>
                        </select>
                    </div>
                </div>
                <div className="form-group m-form__group row">
                    <label className="col-3 col-form-label" style={{textAlign: 'right'}}>
                        Default Bonus<br/>Downline Level
                    </label>
                    <div className="col-6" style={{margin:'auto'}}>
                        <input className="form-control m-input" 
                        type="text" 
                        name="default_bonus_level_text"
                        onChange={(e) => this.on_input_change(e)}
                        value={this.state.settings.default_bonus_level_text}/>
                    </div>
                    <div className="col-3" style={{margin:'auto'}}>
                        <select className="form-control m-input" id="default_bonus_level_type" value={this.state.settings.default_bonus_level_type} onChange={(e) => this.on_select_change(e)} style={{MozAppearance: 'none',WebkitAppearance: 'none'}}>
                            <option key={999} value=""></option>
                            <option key={0} value="FIXED">FIXED</option>
                            <option key={1} value="PERCENTAGE">PERCENTAGE</option>
                        </select>
                    </div>
                </div>
            </div>

        let current_page = ''
        if (this.state.type === 'private-agent') {
        	current_page = <AgentProfileView/>
        } else if (this.state.type === 'public-corporate') {
        	current_page = <CorporatePublicProfileView/>
        } else if (this.state.type === 'private-corporate') {
        	current_page = <CorporatePrivateProfileView/>
        }

    	return (
	    	<Modal className="modal" open={true} center onClose={data.close} showCloseIcon={true} closeOnOverlayClick={true} style={{}}>
	            <div className="modal-dialog modal-lg" role="document" style={{marginTop: 0+'px',marginBottom: 0+'px',width: '700px'}}>
	                <div className="modal-content" style={{border:"white"}}>
	                    <div className="modal-header">
	                        <h5 className="modal-title">
	                            PROFILE {this.state.name_full.toUpperCase()}
	                        </h5>
	                    </div>
	                    <div className="modal-body">
	                        {current_page}
                            {this.state.flag_load_data ? 'Tunggu sedang load data profile' : ''}
	                    </div>
	                    <div className="modal-footer" style={{display:'none'}}>
	                        <button type="button" onClick={data.close} className="btn btn-secondary" data-dismiss="modal">
	                            Tutup
	                        </button>
	                    </div>
	                </div>
	            </div>
	        </Modal>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
})

const mapStateToProps = (state) => ({
    session : state.Session,
    profile: state.Profile
})

export default connect(mapStateToProps, mapDispatchToProps)(ModalProfile)



// WEBPACK FOOTER //
// ./src/component/form/dialog_profile.js